var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "307.000000pt",
    height: "408.000000pt",
    viewBox: "0 0 307.000000 408.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,408.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1333 4046 c-301 -57 -597 -248 -778 -501 -87 -123 -155 -267 -196 -417 -21 -76 -23 -112 -28 -408 l-6 -325 -163 -3 -163 -2 4 -923 c3 -1027 -2 -957 74 -1107 51 -101 189 -242 283 -288 143 -70 87 -67 1170 -67 l975 0 82 23 c168 49 352 193 420 332 65 131 63 91 63 1107 l0 923 -160 0 -160 0 0 269 c0 148 -5 304 -11 347 -34 246 -152 484 -334 672 -174 181 -359 291 -591 353 -103 27 -373 35 -481 15z m387 -167 c202 -37 429 -164 576 -321 120 -129 206 -284 251 -457 25 -91 26 -113 31 -403 l4 -308 -1042 0 -1042 0 4 318 c4 284 7 325 26 393 48 177 132 327 252 453 257 271 597 388 940 325z m1178 -2501 l-3 -843 -31 -65 c-59 -125 -182 -231 -314 -271 -63 -19 -91 -19 -1045 -17 l-980 3 -67 33 c-123 61 -218 167 -261 295 -22 61 -22 74 -25 885 l-3 822 1366 0 1365 0 -2 -842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798 1303 l-448 -448 -209 209 c-181 181 -214 209 -240 209 -55 0 -99 -60 -81 -108 5 -14 112 -131 237 -261 l227 -235 52 3 52 3 481 470 c288 281 484 480 490 497 19 54 -23 108 -83 108 -27 0 -87 -56 -478 -447z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureSite);
export default __webpack_public_path__ + "static/media/secure-site.833dd0ff39140b69c954922c53fcb2a0.svg";
export { ForwardRef as ReactComponent };